// extracted by mini-css-extract-plugin
module.exports = {"buttons":"popups_buttons_3jbNy","button":"popups_button_3X0AZ","active":"popups_active_3BF93"};